import { Skeleton, LinearProgress, Stack } from '@mui/material';
import { MainImageContainer, MainImage, ZoomControlsContainer, ZoomButton } from './styles';
import { EmptyPlaceholder } from '../styles';
import { ZoomIn, ZoomOut } from '@mui/icons-material';

interface MainImageSectionProps {
  currentImage?: {
    src?: string;
    name?: string;
    type?: string;
    isLoading?: boolean;
  };
  mainImageLoading: boolean;
  imageTransform?: React.CSSProperties;
  imageEventHandlers?: React.HTMLAttributes<HTMLImageElement>;
  handleImageLoad?: () => void;
  handleImageError?: () => void;
  canZoomIn: boolean;
  canZoomOut: boolean;
  handleZoom: (direction: 'in' | 'out') => React.MouseEventHandler<HTMLButtonElement>;
}

export const MainImageSection = ({
  currentImage,
  mainImageLoading,
  imageTransform,
  imageEventHandlers,
  handleImageLoad,
  handleImageError,
  canZoomIn,
  canZoomOut,
  handleZoom,
}: MainImageSectionProps) => (
  <MainImageContainer>
    {(currentImage?.isLoading || (currentImage?.type !== 'viewpoint' && mainImageLoading)) && (
      <Skeleton
        variant="rectangular"
        width="100%"
        height="100%"
        sx={{ position: 'absolute', top: 0, left: 0, zIndex: 1 }}
      />
    )}
    {currentImage?.src ? (
      <>
        <MainImage
          src={currentImage.src}
          alt={`POI Image ${currentImage?.name}`}
          style={{
            ...imageTransform,
            visibility: currentImage?.type !== 'viewpoint' && mainImageLoading ? 'hidden' : 'visible',
          }}
          {...imageEventHandlers}
          onLoad={handleImageLoad}
          onError={handleImageError}
        />
      </>
    ) : (
      <EmptyPlaceholder
        sx={{
          width: '100%',
          height: '100%',
          minHeight: '400px',
        }}
      >
        <Stack alignItems="center" spacing={3}>
          <Stack alignItems="center" spacing={2}>
            <img
              src="/assets/abyss_fabric_mini_logo_black.svg"
              alt="Abyss Fabric"
              style={{ height: '4.8rem', width: 'auto' }}
            />
            <LinearProgress sx={{ width: '20rem' }} />
          </Stack>
        </Stack>
      </EmptyPlaceholder>
    )}

    <ZoomControlsContainer>
      <ZoomButton onClick={handleZoom('in')} disabled={!canZoomIn || currentImage?.isLoading}>
        <ZoomIn />
      </ZoomButton>
      <ZoomButton onClick={handleZoom('out')} disabled={!canZoomOut || currentImage?.isLoading}>
        <ZoomOut />
      </ZoomButton>
    </ZoomControlsContainer>
  </MainImageContainer>
);